<template>
  <div>
    <b-modal id="modalItemsTrackingHistoryEvents" size="lg" ref="modalItemsTrackingHistoryEvents" hide-footer @hide="itemSelected = {}">
      <template #modal-title>
        <span v-translate="{refCode: itemSelected.reference_code || itemSelected.description || ''}"><span class="badge badge-dark">%{refCode}</span> Tracking Events History</span>
      </template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <tracking-history-events :item="itemSelected" />
    </b-modal>

    <b-modal id="modalItemsShippingHistory" size="xl" ref="modalItemsShippingHistory" hide-footer @hide="itemSelected = {}">
      <template #modal-title>
        <span v-translate="{refCode: itemSelected.reference_code || itemSelected.description || ''}"><span class="badge badge-dark">%{refCode}</span> Shippings History</span>
      </template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <shipping-history :item="itemSelected" />
    </b-modal>

    <b-modal id="modalItemsTrackingHistory" size="full" ref="modalItemsTrackingHistory" hide-footer @hide="itemSelected = {}">
      <template #modal-title>
        <span v-translate="{refCode: itemSelected.reference_code || itemSelected.description || ''}"><span class="badge badge-dark">%{refCode}</span> Tracking History</span>
      </template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <tracking-history :item="itemSelected" />
    </b-modal>
  </div>
</template>

<script>
import TrackingHistoryEvents from '@/components/Items/TrackingHistoryEvents'
import ShippingHistory from '@/components/Items/ShippingHistory'
import TrackingHistory from '@/components/Items/TrackingHistory'

export default {
  name: 'ItemsMixin',
  components: {
    TrackingHistoryEvents,
    ShippingHistory,
    TrackingHistory
  },
  data() {
    return {
      itemSelected: {}
    }
  },
  created() {
    this.$root.$on('Items::TrackingHistoryEvents::show', (item) => {
      this.itemSelected = item
      this.$bvModal.show('modalItemsTrackingHistoryEvents')
    })
    this.$root.$on('Items::TrackingHistory::show', (item) => {
      this.itemSelected = item
      this.$bvModal.show('modalItemsTrackingHistory')
    })
    this.$root.$on('Items::ShippingHistory::show', (item) => {
      this.itemSelected = item
      this.$bvModal.show('modalItemsShippingHistory')
    })
  }
}
</script>
